export const ValidDemoPartners = [
  'hpTrackin',
  'C95DCBEE-7D12-47AC-B527-E4B320834B3B', // ClearPath-dev
  '27356E55-C7DA-4594-BA13-AADD7F44FD67', // Xirgo
  '7E3BE02F-C702-44F0-A602-0C36A9E87E45', // Xirgo Test Environment
]

export function isValidDemoPartner(partnerPoolId) {
  return ValidDemoPartners.includes(partnerPoolId);
}